import { ListItemButton, ListItemIcon } from "@mui/material";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { RootAppState } from "../../redux/store";
import { RouteType } from "../../routes/config";
import colorConfigs from "../../configs/colorConfigs";

type Props = {
  item: RouteType;
  closeDrawer: () => void;
};

const SidebarItem = ({ item, closeDrawer }: Props) => {
  const { appState } = useSelector((state: RootAppState) => state.appState);

  return item.sidebarProps && item.path && item.show ? (
    <ListItemButton
      onClick={closeDrawer}
      component={Link}
      to={item.path}
      sx={{
        paddingLeft: 2, // Aumenta o padding conforme o nível do item
        backgroundColor:
          appState === item.state ? colorConfigs.sidebar.activeBg : "unset",
        borderRadius: "25px",
        "&: hover": {
          backgroundColor: colorConfigs.sidebar.hoverBg,
          borderRadius: "25px",
        },
      }}
    >
      <ListItemIcon
        sx={{
          color: colorConfigs.sidebar.color,
        }}
      >
        {item.sidebarProps.icon && item.sidebarProps.icon}
      </ListItemIcon>
      {item.sidebarProps.displayText}
    </ListItemButton>
  ) : null;
};

export default SidebarItem;
